// extracted by mini-css-extract-plugin
module.exports = {"item":"_e4b15cd7","icon":"_b29d2237"};